/**
 * Quiz Count + preference defaults.
 *
 * The current onboarding contract is only a daily worksheet count from 1 to 5.
 *
 * Why a separate lib from `lib/tema.ts` / `lib/activity.ts`:
 *  - Count is a scalar (1-5), not a multi-select.
 */

import type { DailyCount } from '@funpaper/shared';

export { ACTIVITY_LIST } from './activity';

/** Bounds for the worksheet count slider (Doc 04 §8.4). */
export const COUNT_MIN = 1;
export const COUNT_MAX = 5;
export const DEFAULT_COUNT: DailyCount = 3;

// ----------------------------------------------------------------------------
// Phase 5.3: Edit Preferences — Tema + Activity lists
// ----------------------------------------------------------------------------

/** 14 PAUD-specific tema (mirrors the 14 tema table on the server).
 *  Ikon chip dirender dari temaIcon(label) di lib/icons.ts (Fase 3 redesign). */
export const TEMA_LIST: readonly { slug: string; label: string }[] = [
  { slug: 'Tanaman',          label: 'Tanaman' },
  { slug: 'Kebutuhanku',     label: 'Kebutuhanku' },
  { slug: 'Diri Sendiri',    label: 'Diri Sendiri' },
  { slug: 'Lingkungan',      label: 'Lingkungan' },
  { slug: 'Alam Semesta',    label: 'Alam Semesta' },
  { slug: 'Kendaraan',       label: 'Kendaraan' },
  { slug: 'Tanah Airku',     label: 'Tanah Airku' },
  { slug: 'Rekreasi',        label: 'Rekreasi' },
  { slug: 'Pekerjaan',       label: 'Pekerjaan' },
  { slug: 'Bepergian',       label: 'Bepergian' },
  { slug: 'Alat Komunikasi', label: 'Alat Komunikasi' },
  { slug: 'Profesi',         label: 'Profesi' },
  { slug: 'Negaraku',        label: 'Negaraku' },
  { slug: 'Air Udara Api',   label: 'Air Udara Api' },
] as const;

/**
 * Type alias for the in-memory preferences shape used by the Edit
 * Preferences screen. Mirrors UserPreferences from @funpaper/shared.
 */
export type AppPreferences = {
  preferredTema: string[];
  preferredActivity: string[];
  dailyCount: number;
  difficulty: 'easy' | 'balanced' | 'challenging';
};

/** Default skip value for Quiz Count. */
export const COUNT_DEFAULT_SKIP: DailyCount = DEFAULT_COUNT;
